/** Runtime configuration: `window.SOLAROS_PLATFORM` (written by docker-entrypoint.sh) over the build-time VITE_*
 * variables. Empty `apiUrl` = same origin (the Vite dev proxy, or a reverse proxy in front of the app). */
interface RuntimeConfig {
  apiUrl?: string;
  authAuthority?: string;
  authClientId?: string;
  authScope?: string;
  authMode?: string;
  wordpressPluginUrl?: string;
}

declare global {
  interface Window {
    SOLAROS_PLATFORM?: RuntimeConfig;
  }
}

const runtime: RuntimeConfig = (typeof window !== "undefined" && window.SOLAROS_PLATFORM) || {};
const env = import.meta.env;

function pick(runtimeValue: string | undefined, buildValue: string | undefined, fallback = ""): string {
  if (runtimeValue !== undefined && runtimeValue !== "") return runtimeValue;
  return buildValue ?? fallback;
}

const authority = pick(runtime.authAuthority, env.VITE_AUTH_AUTHORITY);

export const config = {
  apiUrl: pick(runtime.apiUrl, env.VITE_API_URL).replace(/\/+$/, ""),
  authAuthority: authority,
  authClientId: pick(runtime.authClientId, env.VITE_AUTH_CLIENT_ID),
  /** Extra scopes for the API access token, e.g. `api://<api app id>/access_as_user`. */
  authScope: pick(runtime.authScope, env.VITE_AUTH_SCOPE),
  /** `oidc` when an authority is configured, else `dev` (the backend's AUTH_MODE=dev headers). */
  authMode: (pick(runtime.authMode, env.VITE_AUTH_MODE) || (authority ? "oidc" : "dev")) as "oidc" | "dev",
  wordpressPluginUrl: pick(runtime.wordpressPluginUrl, env.VITE_WORDPRESS_PLUGIN_URL),
};

/** The API origin as the widget and snippets must name it (absolute, even when the app uses a proxy). */
export function publicApiOrigin(): string {
  return config.apiUrl || window.location.origin;
}
